import api from '@/components/mixins/baseApi';
import userMethods from '@/components/mixins/methodsUser';
import push, { clearPushAskState } from '@/components/mixins/methodsPush';
import programFavorite, {
  clearProgramFavorite,
  PROGRAM_FAVORITE_API_READY,
} from '@/components/mixins/api/apiMethodsProgramFavorite';

export default {
  mixins: [api, userMethods, push, programFavorite],
  methods: {
    /**
     * Выход из учётной записи.
     *
     * Порядок важен: подписку снимаем, пока токен ещё жив. Наоборот запрос на
     * удаление уйдёт неавторизованным, и сервер продолжит слать push человеку,
     * который уже вышел.
     *
     * Очередь сканера и кеш конфига не трогаем — они переживают выход. А вот
     * избранное деловой программы стираем: после входа локальная копия хранит
     * уже серверный список, и следующий человек на этом же телефоне увидел бы
     * чужие отметки как свои. Цена решения: отметки, накопленные гостем,
     * переживают вход (уезжают на сервер), но не переживают выход.
     *
     * Пока флаг выключен, избранное никуда не уезжает и живёт только в браузере
     * — стирать его при выходе значило бы отнимать у человека его же календарь
     * без всякой пользы.
     */
    logoutUser() {
      return this.unsubscribePush()
        .catch(() => false)
        .then(() => {
          clearPushAskState();
          if (PROGRAM_FAVORITE_API_READY) clearProgramFavorite(this.$store.getters.getExhId);

          this.$store.commit('setToken', null);
          this.$store.commit('setUserID', null);
          this.$store.commit('setUserRole', null);
          localStorage.removeItem('token');
        });
    },
    sendLogin(data) {
      return this.baseAxios({
        method: 'post',
        url: `${this.$store.getters.apiBasePath}/login`,
        data,
      })
        .then((_data) => {
          console.log(_data);
          return _data?.results ? _data.results : null;
        })
        .catch((error) => {
          Promise.reject(error);
        });
    },
    // Вход по ссылке быстрой авторизации. В отличие от sendLogin статусы ответа
    // разбирает вызывающий экран — см. docs/fast-login.md
    sendLoginByHash(userHash) {
      return this.baseAxios({
        method: 'post',
        url: `${this.$store.getters.apiBasePath}/login`,
        data: { user_hash: String(userHash).toLowerCase() },
        silentErrors: true,
      })
        .then((data) => (data?.results ? data.results : null));
    },
    // Общая часть обоих входов: сохранить токен и подтянуть профиль.
    // Токен без профиля приложению бесполезен — приходится снимать, иначе
    // человек останется наполовину авторизованным и без своего id.
    applyLoginResult(token) {
      this.$store.commit('setToken', token);
      localStorage.setItem('token', token);

      return this.getUserProfile(true)
        .then((data) => {
          if (!data || !data.id) {
            return Promise.reject(new Error('profile is unavailable'));
          }
          this.$store.commit('setUserID', data.id);
          this.$store.commit('setUserRole', data.role || null);
          this.handoffProgramFavorite();
          return data;
        })
        .catch((error) => {
          this.$store.commit('setToken', null);
          localStorage.removeItem('token');
          return Promise.reject(error);
        });
    },
  },
};
